import { FC } from 'react'

import { ISvgClass } from '../interface'

const PencilIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M19.3 9.175L15.05 4.975L16.45 3.575C16.8333 3.19167 17.3043 3 17.863 3C18.4217 3 18.8923 3.19167 19.275 3.575L20.675 4.975C21.0583 5.35833 21.2583 5.821 21.275 6.363C21.2917 6.905 21.1083 7.36733 20.725 7.75L19.3 9.175ZM17.85 10.65L7.25 21.25H3V17L13.6 6.4L17.85 10.65Z"
        fill="inherit"
      />
    </svg>
  )
}

export default PencilIcon
